import { Injectable } from '@angular/core';

import { SiteTypeEnum } from '../../enums';
import { QuickRepliesElementsConfiguration } from '../../models';
import { StrategyAbstractService } from '../strategy-abstract.service';

@Injectable({
  providedIn: 'root',
})
/**
 * AlcmeonChat
 */
export class WebchatService extends StrategyAbstractService {
  constructor() {
    super();
  }

  getType(): number {
    return 10; // alcmeon.db.Sites.TYPE_WEBCHAT
  }
  getTypeString(): string {
    return SiteTypeEnum.InMessage;
  }
  getAllTasksTypes(): number[] {
    return [32];
  }
  getTaskTypeString(taskType: number): string {
    const mapping = {
      32: 'webchat/msg',
    };
    return mapping[taskType];
  }

  getTaskTypeQueueId(taskType: number): string {
    const mapping = {
      32: 'webchat-msg',
    };
    return mapping[taskType];
  }

  getPrivateTaskTypes(): number[] {
    return [32];
  }

  canHaveSurveys(): boolean {
    return true;
  }

  getQuickRepliesElementsConfig(): QuickRepliesElementsConfiguration {
    return {
      maxAnswerNb: 11,
      answerLabelMaxLength: 50,
      hasDescription: false,
      canHaveUserVariableInRootQuestion: true,
      hasPhoneEmailAnswerType: false,
      hasUrlAnswerType: false,
      hasTargetAppId: false,
      boxesCanBeTested: false,
      hasPersistentMenu: true,
      hasWelcomeMessage: false,
      imageMimeTypes: 'image/*',
      editorConfiguration: {
        fileEnabled: true,
        hasImageControl: false,
      },
      hasAddUrlButtonButton: true,
      sendTextAfterButtonChoice: false,
      canSendVideo: true,
    };
  }
}
